import React, { useState } from "react";
import { useSelector } from "react-redux";
import { locationDev } from "../../services/Servicos";
import UserImageModal from "./UserImageModal";
import "./UserAvatar.scss";

export default function UserAvatar({ 
	size = "medium", 
	showName = true, 
	className = "",
	customName = null,
	onClick = null,
	user = null,
	showImageModal = true // New prop to control modal functionality
}) {
	const [showModal, setShowModal] = useState(false);
	
	// Use custom props or fallback to user prop or current user
	const fotoPerfil = user?.foto_perfil;
	const userName = user?.name || customName || "Usuário";
	
	// Extract first name and first letter of last name
	const getDisplayName = (fullName) => {
		if (!fullName) return "Usuario";
		const nameParts = fullName.trim().split(" ");
		const firstName = nameParts[0];
		const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
		return lastName ? `${firstName} ${lastName}` : firstName;
	};

	// Get initials for fallback display
	const getInitials = (fullName) => {
		if (!fullName) return "U";
		const nameParts = fullName.trim().split(" ");
		const firstInitial = nameParts[0]?.charAt(0)?.toUpperCase() || "";
		const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1]?.charAt(0)?.toUpperCase() || "" : "";
		return lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
	};

	const displayName = getDisplayName(userName);
	const initials = getInitials(userName);

	const handleClick = () => {
		if (onClick && typeof onClick === "function") {
			onClick();
		}
	};

	const handleImageClick = (e) => {
		e.stopPropagation(); // Prevent triggering the container's onClick
		if (showImageModal && (fotoPerfil || userName)) {
			setShowModal(true);
		}
	};

	const handleCloseModal = () => {
		setShowModal(false);
	};

	return (
		<div 
			className={`user-avatar ${size} ${className} ${onClick ? 'clickable' : ''}`}
			onClick={handleClick}
		>
			<div 
				className={`user-avatar-image ${showImageModal ? 'modal-clickable' : ''}`}
				onClick={handleImageClick}
			>
				{fotoPerfil ? (
					<img
						src={fotoPerfil.startsWith('http') ? fotoPerfil : `${locationDev}/files/users/${fotoPerfil}`}
						alt={`${displayName} profile`}
						className="avatar-img"
						onError={(e) => {
							e.target.style.display = 'none';
							e.target.nextSibling.style.display = 'flex';
						}}
					/>
				) : null}
				<div 
					className="avatar-fallback"
					style={{ display: fotoPerfil ? 'none' : 'flex' }}
				>
					{initials}
				</div>
			</div>
			{showName && (
				<span className="user-avatar-name">{displayName}</span>
			)}
			
			{/* Image Modal */}
			<UserImageModal
				show={showModal}
				onHide={handleCloseModal}
				userImage={fotoPerfil}
				userName={displayName}
			/>
		</div>
	);
}
